'use es6';

export const getFrameworkBuilderMetaDataValue = (fieldName, metadata) => {
  if (metadata[fieldName] && metadata[fieldName].value !== 'null') {
    return metadata[fieldName].value;
  }
  return undefined;
};